import { render, staticRenderFns } from "./CreateCompanies.vue?vue&type=template&id=2356f8cb&"
import script from "./CreateCompanies.vue?vue&type=script&lang=js&"
export * from "./CreateCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports